import { useState } from "react";
import { Link, useLocation } from "wouter";
import logo from "../assets/img/technova_logo_white.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [location] = useLocation();

  const navLinks = [
    { path: "/", label: "Inicio" },
    { path: "/services", label: "Servicios" },
    { path: "/about", label: "Sobre Nosotros" },
    { path: "/contact", label: "Contacto" },
  ];

  const isActive = (path) => location === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#033644] shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link 
            href="/" 
            data-testid="link-home"
            className="text-white font-heading font-bold text-xl md:text-2xl hover:text-[#FFA500] transition-colors duration-300"
          >
            <img src={logo} alt="Technova Logo" className="h-12 md:h-16" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link 
                key={link.path} 
                href={link.path} 
                data-testid={`link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={`text-white font-medium transition-all duration-300 ${
                  isActive(link.path)
                    ? "border-b-2 border-[#FFA500] text-[#FFA500]"
                    : "hover:text-[#FFA500]"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white p-2 rounded-md hover:bg-[#044555] transition-colors duration-300"
            data-testid="button-mobile-menu"
            aria-label="Toggle menu"
          >
            <i className={`fas ${isOpen ? "fa-times" : "fa-bars"} text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4 animate-in slide-in-from-top duration-300">
            <div className="flex flex-col space-y-3">
              {navLinks.map((link) => (
                <Link 
                  key={link.path} 
                  href={link.path} 
                  data-testid={`link-mobile-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-2 rounded-md text-white font-medium transition-colors duration-300 ${
                    isActive(link.path)
                      ? "bg-[#044555] text-[#FFA500]"
                      : "hover:bg-[#044555] hover:text-[#FFA500]"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}